import { useQuery } from '@apollo/client';
import mergeOperations from '@magento/peregrine/lib/util/shallowMerge';
import DEFAULT_OPERATIONS from './downloads.gql';
export var useDownloads = function useDownloads() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var operations = mergeOperations(DEFAULT_OPERATIONS, props.operations);
  var getPimcoreAssetHost = operations.getPimcoreAssetHost;

  var _useQuery = useQuery(getPimcoreAssetHost, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first'
  }),
      data = _useQuery.data;

  return {
    pimcoreAssetHost: data && data.storeConfig && data.storeConfig.pimcore_assets_host
  };
};